import ky from 'ky';

export default ky;
